<template>
  <div class="CadastroUsuarios">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/termometria' }">Orçamentos Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Itens</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="text-align: left;">
      <el-col>
        <p>
          Orçamento: <strong>{{orcamentoTermometria.id.toString().padStart(6, "0") }}</strong> <br/>
          Cliente: <strong>{{orcamentoTermometria.cliente}}</strong> <br/>
          Negócio: <strong>{{orcamentoTermometria.numNegocio}}</strong> - Versão: <strong>{{orcamentoTermometria.numNegocioVersao}}</strong> <br/>
          Sub Total: <strong>{{formataDolarToReal(parseFloat(orcamentoTermometria.subtotal))}}</strong> <br/>
          IPI: <strong>{{formataDolarToReal(parseFloat(orcamentoTermometria.ipi))}}</strong> <br/>
          Total: <strong>{{formataDolarToReal(parseFloat(orcamentoTermometria.total))}}</strong>
        </p>
      </el-col>
    </el-row>
    <el-row v-if="permissao.editar_termometria" type="flex" justify="left">
      <el-col :xs="24" :sm="24" :md="20" :lg="2" :xl="1">
        <h1>
            <el-button type="primary" @click="handleInsert()" icon="el-icon-circle-plus-outline" round>Novo</el-button>
        </h1>
        <router-view />
      </el-col>
    </el-row>
    <el-tabs type="card" style="margin-top:20px;">
      <el-tab-pane label="Termometria Itens">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-table
              :data="orcamentoTermometriaItens"
              style="width: 100%"
              stripe
              v-loading="loading"
              element-loading-text="Loading..."
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 255, 255, 0.7)"
            >
              <el-table-column label="Descrição">
                <template v-slot="scope">
                  {{ descricaoProduto(scope.row.produto_id) }}
                </template>
              </el-table-column>
              <el-table-column prop="modelo" label="Modelo" width="200"></el-table-column>
              <el-table-column prop="cod_nbr" label="Cód NBR" width="100"></el-table-column>
              <el-table-column prop="cod_fornecedor" label="Cód Fornecedor" width="150"></el-table-column>
              <el-table-column prop="qtde" label="Qtde" width="100" align="right" header-align="right"></el-table-column>
              <el-table-column label="Unitário" width="100" align="right" header-align="right">
                <template v-slot="{ row }">
                  <span> {{formataDolarToReal(parseFloat(row.valor_unitario))}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Total" width="100" align="right" header-align="right">
                <template v-slot="{ row }">
                  <span> {{formataDolarToReal(parseFloat(row.subtotal))}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="acao" label="Ação" filter-placement="bottom-end"  width="110">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-tooltip v-if="permissao.editar_termometria" class="item" effect="light" content="Editar" placement="top">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="handleEdit(scope.row)"
                        icon="el-icon-document-copy"
                      ></el-button>
                    </el-tooltip>                
                    <el-tooltip v-if="permissao.excluir_termometria" class="item" effect="light" content="Excluir" placement="top">
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.row)"
                        icon="el-icon-delete"
                      ></el-button>
                    </el-tooltip>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>


    <!-- DIALOG DE CADASTRO DE AVISOS -->
    <el-dialog title="Novo Item Orçamento Termometria" :visible="dialogFormVisible" :show-close="false">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
      <el-form-item label="Produto" prop="descricao" class="listas">
        <el-select
          v-model="ruleForm.produto_id"
          filterable
          v-on:change="definePrecoProduto"
          placeholder="Informe o Produto"
        >
          <el-option
            v-for="item in listProdutos"
            :key="item.id"
            :label="item.descricao"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>



        <el-form-item label="Quantidade" prop="qtde">
          <el-input type="number" v-model="ruleForm.qtde" @input="calcularSubtotal"></el-input>
        </el-form-item>
        <el-form-item label="Unitário" prop="valor_unitario">
          <el-input type="number" v-model="ruleForm.valor_unitario" disabled></el-input>
        </el-form-item>
        <el-form-item label="Total" prop="subtotal">
          <el-input type="number" v-model="ruleForm.subtotal" disabled></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFechar()">Cancelar</el-button>
        <el-button type="primary" @click="orcamentoTermometriaItemGravar('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>

    <!-- DIALOG DE EDIÇÃO DE AVISOS -->
    <el-dialog title="Editar Item Orçamento Termometria" :visible="dialogFormVisibleEdit" :show-close="false">
      <el-form
        :model="ruleFormEdit"
        ref="ruleFormEdit"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
      <el-form-item label="Produto" class="listas">
        <el-select
          v-model="ruleFormEdit.produto_id"
          filterable
          v-on:change="definePrecoProduto"
          placeholder="Informe o Produto"
        >
          <el-option
            v-for="item in listProdutos"
            :key="item.id"
            :label="item.descricao"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="Quantidade" prop="qtde">
          <el-input type="number" v-model="ruleFormEdit.qtde" @input="calcularSubtotal"></el-input>
        </el-form-item>
        <el-form-item label="Unitário" prop="valor_unitario">
          <el-input type="number" v-model="ruleFormEdit.valor_unitario" disabled></el-input>
        </el-form-item>
        <el-form-item label="Total" prop="subtotal">
          <el-input type="number" v-model="ruleFormEdit.subtotal" disabled></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFecharEdit()">Cancelar</el-button>
        <el-button type="primary" @click="orcamentoTermometriaItemEditar('ruleFormEdit')">Salvar</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  components: {
  },

  data() {
    return {
      loading: false,
      listProdutos: [],
      permissao: {},
      precoProduto: 0,
      descricao: "",
      cod_nbr: 0,
      cod_fornecedor: 0,
      modelo: "",
      termometria_id: 0,
      termometria_item_id: 0,
      orcamentoTermometriaItens: [],
      orcamentoTermometria: {
        id: 0,
        cliente: "",
        numNegocio: 0,
        numNegocioVersao: 0,
        subtotal: 0,
        ipi: 0,
        total: 0,
      },
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      ruleForm: {
        produto_id: null,
        descricao: "",
        modelo: "",
        cod_fornecedor: 0,
        cod_nbr: 0,
        qtde: 1,
        valor_unitario: 0,
        subtotal: 0,
      },
      ruleFormEdit: {
        produto_id: null,
        descricao: "",
        modelo: "",
        cod_fornecedor: 0,
        cod_nbr: 0,
        qtde: 1,
        valor_unitario: 0,
        subtotal: 0,
      },
      labelPosition: "right",
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.editar_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.termometria_id = this.$route.params.id
    this.exibeOrcementoTermometria()
    this.listaItens()
    axios
      .get(url + "/produtos", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listProdutos = resp.data;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });
  },
  methods: {
    exibeOrcementoTermometria() {
      axios
      .get(url + "/orcamentotermometria/" + this.termometria_id, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.orcamentoTermometria.id = resp.data.id
          this.orcamentoTermometria.cliente = resp.data.cliente
          this.orcamentoTermometria.numNegocio = resp.data.num_negocio
          this.orcamentoTermometria.numNegocioVersao = resp.data.versao
          this.orcamentoTermometria.subtotal = resp.data.subtotal
          this.orcamentoTermometria.ipi = resp.data.ipi
          this.orcamentoTermometria.total = resp.data.total
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });
    },
    listaItens() {
    axios
      .get(url + "/termoitemlist/" + this.termometria_id, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.orcamentoTermometriaItens = resp.data;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });
    },
    handleFechar() {
        this.$confirm("Tem certeza que deseja sair, sem salvar?", "Aviso", {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning",
        })
          .then(() => {
            this.dialogFormVisible = false;
          })
          .catch(() => {
            this.dialogFormVisible = true;
          });
    },
    handleFecharEdit() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisibleEdit = false;
        })
        .catch(() => {
          this.dialogFormVisibleEdit = true;
        });
    },
    handleInsert() {
      this.dialogFormVisible = true;
      this.ruleForm.termometria_id = this.termometria_id,
      this.ruleForm.produto_id = null;
      this.ruleForm.descricao = '';
      this.ruleForm.modelo = '';
      this.ruleForm.cod_fornecedor = 0;
      this.ruleForm.cod_nbr = 0;
      this.ruleForm.qtde = 1;
      this.ruleForm.valor_unitario = 0;
      this.ruleForm.subtotal = 0;
    },
    handleEdit(row) {
      this.definePrecoProduto(row.produto_id)
      this.dialogFormVisibleEdit = true;
      this.termometria_item_id = row.id;
      this.ruleFormEdit.produto_id = row.produto_id;
      this.ruleFormEdit.descricao = row.descricao;
      this.ruleFormEdit.modelo = row.modelo;
      this.ruleFormEdit.cod_fornecedor = row.cod_fornecedor;
      this.ruleFormEdit.cod_nbr = row.cod_nbr;
      this.ruleFormEdit.qtde = row.qtde;
      this.ruleFormEdit.valor_unitario = row.valor_unitario;
      this.ruleFormEdit.subtotal = row.subtotal;
    },
    handleDelete(row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/termoitemdelete/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.exibeOrcementoTermometria()
              this.listaItens();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    orcamentoTermometriaItemEditar(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dados = {
            produto_id: this.ruleFormEdit.produto_id,
            descricao: this.ruleFormEdit.descricao,
            modelo: this.ruleFormEdit.modelo,
            cod_fornecedor: this.ruleFormEdit.cod_fornecedor,
            cod_nbr: this.ruleFormEdit.cod_nbr,
            qtde: this.ruleFormEdit.qtde,
            valor_unitario: this.ruleFormEdit.valor_unitario,
            subtotal: this.ruleFormEdit.subtotal,
          };
          axios
            .put(url + "/termoitemeditar/" + this.termometria_item_id, dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Alterado com sucesso!",
                type: "success",
              });
              this.dialogFormVisibleEdit = false;
              this.ruleFormEdit.produto_id = null;
              this.ruleFormEdit.descricao = "";
              this.ruleFormEdit.modelo = "";
              this.ruleFormEdit.cod_fornecedor = null;
              this.ruleFormEdit.cod_nbr = null;
              this.ruleFormEdit.qtde = 1;
              this.ruleFormEdit.valor_unitario = 0;
              this.ruleFormEdit.subtotal;
              this.exibeOrcementoTermometria()
              this.listaItens();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao alterar os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
              this.dialogFormVisibleEdit = false;
              this.ruleFormEdit.produto_id = null;
              this.ruleFormEdit.descricao = "";
              this.ruleFormEdit.modelo = "";
              this.ruleFormEdit.cod_nbr = null;
              this.ruleFormEdit.cod_fornecedor = null;
              this.ruleFormEdit.descricao = "";
              this.ruleFormEdit.qtde = 1;
              this.ruleFormEdit.valor_unitario = 0;
              this.ruleFormEdit.subtotal;
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    orcamentoTermometriaItemGravar(){
      let dados = {
        termometria_id: this.ruleForm.termometria_id,
        produto_id: this.ruleForm.produto_id,
        descricao: this.ruleForm.descricao,
        modelo: this.ruleForm.modelo,
        cod_fornecedor: this.ruleForm.cod_fornecedor,
        cod_nbr: this.ruleForm.cod_nbr,
        qtde: this.ruleForm.qtde,
        valor_unitario: this.ruleForm.valor_unitario,
        subtotal: this.ruleForm.subtotal,
      }
      axios
      .post(url + "/termoitemregister", dados, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.dialogFormVisible = false;
          this.exibeOrcementoTermometria();
          this.listaItens();
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });

    },
    definePrecoProduto(value) {
      const produto = this.listProdutos.find(produto => produto.id === value)
      this.precoProduto = produto.valor
      this.cod_nbr = produto.cod_nbr
      this.cod_fornecedor = produto.cod_fornecedor
      this.modelo = produto.modelo
      this.descricao = produto.descricao
      this.calcularSubtotal()
    },
    calcularSubtotal() {
      this.ruleForm.descricao = this.descricao
      this.ruleForm.cod_nbr = this.cod_nbr
      this.ruleForm.cod_fornecedor = this.cod_fornecedor
      this.ruleForm.modelo = this.modelo
      this.ruleForm.valor_unitario = this.precoProduto
      const qtde = parseFloat(this.ruleForm.qtde)
      const valorUnitario = parseFloat(this.ruleForm.valor_unitario)
      this.ruleForm.subtotal = (qtde * valorUnitario).toFixed(2)

      this.ruleFormEdit.descricao = this.descricao
      this.ruleFormEdit.cod_nbr = this.cod_nbr
      this.ruleFormEdit.cod_fornecedor = this.cod_fornecedor
      this.ruleFormEdit.modelo = this.modelo
      this.ruleFormEdit.valor_unitario = this.precoProduto
      const qtde2 = parseFloat(this.ruleFormEdit.qtde)
      const valorUnitario2 = parseFloat(this.ruleFormEdit.valor_unitario)
      this.ruleFormEdit.subtotal = (qtde2 * valorUnitario2).toFixed(2)
    },
    descricaoProduto(id) {
      const produto = this.listProdutos.find(produto => produto.id === id);
      return produto ? produto.descricao : "Não encontrado"; 
    },
    formataDolarToReal(valor,casasDecimais = 2) {
      if (isNaN(valor) || valor === null) return "0,00";
      let val = new String(valor.toFixed(casasDecimais));
      val = val.replace(",","");
      val = val.replace(".","");
      let tmp = val+'';
      tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
      if( tmp.length > 6 )
          tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
      return tmp;
    },
  },
};
</script>
<style>
.bg-purple-light {
  background: #303133;
}
.CadastroUsuarios .grid-content {
  border-radius: 4px;
  min-height: 2px;
  height: 2px;
}
.tec_select label {
  width: 100%;
  text-align: left;
}
.tec_select div {
  width: 100%;
  text-align: left;
}
.encontrar_orc_left {
  text-align: left;
}
.CadastroUsuarios .el-table td,
.el-table th {
  padding: 0px 0 !important;
}
.tabela_cmo .item {
  margin-bottom: 0px !important;
}
.CadastroUsuarios .label_campos {
  /* font-weight: bold; */
  width: 100%;
  display: block;
  padding: 5px 0px;
  margin-top: 0px;
}
.CadastroUsuarios .input_campos {
  font-weight: bold;
  width: 80%;
  display: block;
  border-radius: 5px;
  border: 1px solid #e4e7ed;
  background: #faecd8;
  height: 25px;
  padding-left: 15px;
  padding-top: 10px;
}
.CadastroUsuarios .input_campos_total {
  font-weight: bold;
  width: 80%;
  display: block;
  border-radius: 5px;
  border: 1px solid #e4e7ed;
  background: #e1f3d8;
  height: 25px;
  padding-left: 15px;
  padding-top: 10px;
}
.CadastroUsuarios .espaco_top {
  margin-top: 8px;
  text-align: left;
  padding: 5px 0px;
}
.CadastroUsuarios .listas label {
  width: 100%;
  text-align: left;
}
.CadastroUsuarios .listas .el-input__suffix-inner {
  padding-top: 0px;
  top: 0px !important;
  position: absolute;
  margin-left: -20px;
  margin-top: 40px;
}
.CadastroUsuarios .listas .el-select {
  width: 100%;
  display: block;
}
</style>
